import { render, staticRenderFns } from "./ManagePickUp.vue?vue&type=template&id=6cef8a6a&scoped=true"
import script from "./ManagePickUp.vue?vue&type=script&lang=js"
export * from "./ManagePickUp.vue?vue&type=script&lang=js"
import style0 from "./ManagePickUp.vue?vue&type=style&index=0&id=6cef8a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cef8a6a",
  null
  
)

export default component.exports